// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3670b10c","884":"833dd4a7"}[chunkId] + ".chunk.js";
};